<template>
  <div id="printerDiv">
    <table class="ana">
      <tr>
        <td>
          <table style="min-width:120mm;">
            <tr>
              <td class="fontM" style="width: 50mm;" valign="top">
                Kullanıcı : {{ activePersonal }}
              </td>

              <td class="fontM" style="width: 40mm;" valign="top">
                Fiş No : {{ billId }}
              </td>
            </tr>
            <tr>
              <td class="fontM" style="width: 64mm;" valign="top" colspan="2">
                Tarih : &nbsp;&nbsp;&nbsp; {{ currentDateTime }}
              </td>
            </tr>
          </table>
          <table style="min-width:64mm;">
            <thead>
            <tr class="border-bottom" style="display:block;width:85mm;">
              <td class="heavy fontM" style="width: 50mm;height:20px;" valign="top">
                Ürün
              </td>
              <td class="heavy fontM" style="width: 15mm;" valign="top">
                Miktar
              </td>
              <td class="heavy fontM" style="width: 20mm;" valign="top">
                Tutar
              </td>
            </tr>
            </thead>
            <tbody>
            <tr style="width:85mm;" v-for="entry in orderEntries" :key="entry.id">
              <td>
                <table>
                  <tr>
                    <td class="fontB" style="width: 50mm;" valign="top">
                      {{ entry.productName }}  
                    </td>
                    <td class="fontB" style="width: 15mm;" valign="top">
                      x{{ entry.productQuantity || entry.quantity}}
                    </td>
                    <td class="fontB" style="width: 20mm;" valign="top">
                      {{ $toCurrency(entry.price) }}
                    </td>
                  </tr>
                </table>
                <table>
                  {{ entry.description }}
                  <tr style="width:85mm;" v-for="variant in entry.variantItems" :key="variant.id">
                    <td class="fontMB" style="width: 50mm;" valign="top">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;* {{ variant.name }}
                    </td>
                    <td class="fontMB" style="width: 15mm;" valign="top">

                    </td>
                    <td class="fontMB" style="width: 20mm;" valign="top">

                    </td>
                  </tr>
                </table>
                <table v-if="entry.recipe != null">
                  <tr style="width:85mm;" v-for="step in entry.recipe.steps.filter(x=> (x.isRemovable || (x.name && x.name.includes('Vanilya Şurup')) ) && !entry.variantItems.some(y=> y.id == x.id))" :key="step.id">
                    <td v-if="step.isRemoved === false" class="fontMB" style="width: 50mm;" valign="top">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;* {{ step.name }}
                    </td>
                    <td v-else class="fontMB" style="width: 50mm;" valign="top">
                      <span style="text-decoration: line-through;" class="text-line-through">
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- {{ step.name }}
                        </span>
                    </td>
                    <td class="fontMB" style="width: 15mm;" valign="top">

                    </td>
                    <td class="fontMB" style="width: 20mm;" valign="top">

                    </td>
                  </tr>
                </table>
                <table>
                  <tr style="width:85mm;" v-for="extra in entry.extras" :key="extra.id">
                    <td class="fontMB" style="width: 50mm;" valign="top">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ {{ extra.name }}
                    </td>
                    <td class="fontMB" style="width: 15mm;" valign="top">
                      x{{ extra.quantity }}
                    </td>
                    <td class="fontMB" style="width: 20mm;" valign="top">
                      {{ $toCurrency(extra.price) }}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </table>
    <table style="width:100%;">
      <tr class="text-end justify-end">
        <span class="heavy fontM text-end">Toplam Tutar : {{ $toCurrency(totalPrice) }}</span>
      </tr>
      <tr class="text-end justify-end">
        <span class="heavy fontM text-end">Toplam İndirim : {{ $toCurrency(totalDiscountPrice) }}</span>
      </tr>
      <tr class="text-end justify-end">
        <span
          class="heavy fontM text-end">Toplam Net Tutar : {{ $toCurrency((totalPrice - totalDiscountPrice)) }}</span>
      </tr>
    </table>
  </div>
</template>
<script src="https://www.google.com/cloudprint/client/cpgadget.js"/>
<script>
import companyInfo from '../../../model/constants/companyInfo';
import print from "print-js";

export default {
  props: {
    totalPrice: {
      type: Number,
      required: false
    },
    totalDiscountPrice: {
      type: Number,
      required: false
    },
    orderEntries: {
      type: Array,
      required: false
    },
    currentDateTime: {
      type: String,
      required: false
    },
    activePersonal: {
      type: String,
      required: false
    }
  },
  data() {
    return {
companyName: companyInfo.name

    }
  },
  computed: {
    billId: {
      get() {
        return this.$store.getters["selfservice/getToLastBillId"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLastBillId", val);
      }
    },
  },
  methods: {
    printOrders() {
      try {
        console.log(this.orderEntries);
        printJS({
          showModal: false,
          printable: 'printerDiv',
          type: 'html',
          header: this.companyName,
          style: ".heavy {font-weight: 800;} .justify-end{justify-content:flex-end;} .text-end{text-align:end;} .border-bottom {border-bottom:1px solid #000000;} .fontB {font-size:22px!important;font-weight:600;} .fontM {font-size:16px!important;} .fontMB {font-size:19px!important;} .text-line-through {text-decoration:line-through;}"
        });
      } catch (e) {
      }
    },
  }
}

</script>

<style>
#printerDiv {
  position: absolute;
  left: 30%;
  top: 5%;
  z-index: -1;
  font-size: 15px;
  max-width: 80mm;
  min-height: 150mm;
  line-height: 1; /* Satır yüksekliği */
  margin-bottom: 0; /* Alt boşluk */
  padding-bottom: 0; /* Alt dolgu */
}
#printerDiv table {
  margin-bottom: 0;/* Alt boşluk */
}

#printerDiv table td {
  padding-bottom: 0;/* Alt dolgu */
}
</style>
